import { Link } from 'react-router';
import { AppShell } from '../../components/AppShell';
import { Button } from '../../components/Button';
import { ChevronRightIcon } from '../../components/icons';
import { SettingsNav } from '../../components/SettingsNav';
import { useAuth } from '../../lib/auth';

const LINKS = [
  {
    to: '/settings/profile',
    title: 'Profile',
    text: 'Name, password, email verification, delete account',
  },
  {
    to: '/settings/household',
    title: 'Household',
    text: 'Name, units, members, invites, kitchen equipment',
  },
  {
    to: '/settings/schedule',
    title: 'Meal times & schedule',
    text: 'When you eat, busy evenings, thaw reminders, Google Calendar',
  },
  {
    to: '/settings/places',
    title: 'Meal places',
    text: 'Home, work, school: appliances and banned allergens for packed lunches',
  },
  { to: '/settings/devices', title: 'Devices', text: 'Where you are signed in' },
  { to: '/settings/passkeys', title: 'Passkeys', text: 'Sign in without a password' },
  {
    to: '/stores',
    title: 'Stores',
    text: 'Your stores, department order, shelf-life rules, default products',
  },
];

export function SettingsPage() {
  const { auth, logout } = useAuth();
  return (
    <AppShell title="Settings">
      <SettingsNav />
      <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {LINKS.map((l) => (
          <li key={l.to}>
            <Link to={l.to} className="card card-link flex h-full items-center gap-3 p-4">
              <span className="min-w-0 flex-1">
                <span className="font-semibold text-brand">{l.title}</span>
                <span className="block text-sm text-muted">{l.text}</span>
              </span>
              <ChevronRightIcon className="size-5 shrink-0 text-muted" />
            </Link>
          </li>
        ))}
      </ul>
      <div className="mt-6 flex flex-col gap-2">
        {auth.status === 'authed' ? (
          <p className="text-sm text-muted">
            Signed in as {auth.user.displayName} ({auth.user.email})
          </p>
        ) : null}
        <Button variant="secondary" onClick={() => void logout()}>
          Sign out
        </Button>
      </div>
      <div className="mt-6 flex flex-col gap-1 border-t border-line pt-4 text-sm text-muted">
        <span className="font-semibold text-ink">About</span>
        <span className="flex flex-wrap gap-x-4 gap-y-1">
          <Link
            to="/privacy"
            className="text-brand underline-offset-2 hover:underline"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms"
            className="text-brand underline-offset-2 hover:underline"
            target="_blank"
            rel="noreferrer"
          >
            Terms of Service
          </Link>
        </span>
      </div>
    </AppShell>
  );
}
